"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../../utils/styles/index");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/* ++++++++++ --------------- EXPORT : COPY FIELD : STYLES --------------- ++++++++++ */


var _default = {
  incdecfield: {
    transition: _index.theme.animation.general('all'),
    height: (0, _index.pxToEm)(32),
    '&.disabled-true': _objectSpread({}, _index.disable),
    '& .textfield': {
      textAlign: 'center',
      marginTop: 0
    },
    '& .field': {
      margin: (0, _index.pxToEm)(4),
      width: (0, _index.pxToEm)(76),
      '& .formelement': {
        border: "2px solid rgb(236, 240, 247)"
      }
    },
    '& .cta': {
      width: (0, _index.pxToEm)(36),
      color: '#1494F4',
      '& .icon': {
        '& i': {
          fontSize: (0, _index.pxToEm)(14),
          marginRight: 0
        }
      }
    },
    // ----- props ----- //
    '&.ctaPosition': {
      '&-inline': {
        display: 'flex',
        flexDirection: 'row',
        '& .field': {
          marginRight: function marginRight(props) {
            return (0, _index.replacePXinStringWithEM)("".concat(props.spaceBetweenFieldAndButton));
          }
        }
      }
    },
    '&.fieldHeight': {
      '&-inline': {
        alignItems: 'center',
        whiteSpace: 'nowrap'
      }
    }
  }
};
exports.default = _default;